import { useCallback } from 'react';
import { signOut } from 'firebase/auth';
import { setLogoutHistoryCutoff } from '../../nativeBridge/hooks/useBackButtonBridge';
import { auth } from '../lib/firebase';

export interface ILogoutButtonProps {
  className?: string;
  text?: string;
}

export const LogoutButton = ({ className, text }: ILogoutButtonProps) => {
  // const { executeAsync: executeSignOutActionAsync } = useAction(signOutAction);

  const handleLogout = useCallback(async () => {
    try {
      await signOut(auth);
      setLogoutHistoryCutoff(window.history.length);
      console.log(
        `%cMAKE THE LOGOUTE API CALL HERE`,
        'color: #221; background: #F40;padding: 2px 8px; font-weight: bold'
      );
      // await executeSignOutActionAsync();
    } catch (error) {
      console.error('Error during logout:', error);
    }
  }, []);

  return (
    <button onClick={handleLogout} className={className}>
      {text || 'Logout'}
    </button>
  );
};
